/** 

=========================================================
* Vision UI PRO React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Visionware.

*/

// React imports
import { useState, useEffect } from 'react';

// @mui material components
import Card from '@mui/material/Card';
import CircularProgress from '@mui/material/CircularProgress';

// Vision UI Dashboard PRO React components
import VuiBox from 'components/VuiBox';
import VuiTypography from 'components/VuiTypography';
import VuiButton from 'components/VuiButton';

// React Router
import { Link } from 'react-router-dom';

// API
import api from 'services/api';

function ContentApproval() {
  const [pendingCount, setPendingCount] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPendingCount = async () => {
      try {
        setLoading(true);
        setError(null);
        
        // This endpoint returns all-time pending count (no date filtering)
        const response = await api.get('/overviewDash/pending');
        
        // Extract the takedowns_pending value and convert to number
        // API returns this as a string, so we need to parse it
        const total = parseInt(response.data?.takedowns_pending, 10) || 0;
        setPendingCount(total);
      } catch (err) {
        setError(err.message);
        // Set to 0 on error so the UI still displays something
        setPendingCount(0);
      } finally {
        setLoading(false);
      }
    };

    fetchPendingCount();
  }, []);

  return (
    <Card sx={{ height: '100%', padding: '24px' }}>
      <VuiBox display="flex" flexDirection="column" height="100%">
        <VuiTypography variant="lg" color="white" fontWeight="bold" mb={2}>
          CONTENT APPROVAL
        </VuiTypography>
        <VuiBox display="flex" flexDirection="column" justifyContent="center" alignItems="center" flex={1}>
          {loading ? (
            <CircularProgress size={40} sx={{ color: '#0075FF' }} />
          ) : (
            <>
              <VuiTypography variant="h1" color="white" fontWeight="bold" mb={2}>
                {pendingCount !== null ? pendingCount : '—'}
              </VuiTypography>
              <VuiTypography variant="button" color="text" fontWeight="regular" mb={3}>
                PENDING TAKEDOWNS TO REVIEW
              </VuiTypography>
              <Link to="/applications/reviewcontent"> 
              <VuiButton color="info" size="medium">
                VIEW
              </VuiButton>
              </Link>
            </>
          )}
          {error && !loading && (
            <VuiTypography variant="caption" color="error" mt={1}>
              Failed to load
            </VuiTypography>
          )}
        </VuiBox>
      </VuiBox>
    </Card>
  );
}

export default ContentApproval;
